import React, { useEffect, useState } from "react";
import styles from "../Profile/Profile.module.css";
import multipleEntry from "../../assests/popup/multipleEntry.svg";
import { useUserAuth } from "../../context/UserAuthContext";

function VoucherPaymentPopup({ buttonColor, setPopup, handleNext, loading }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { searchParams } = useUserAuth();
  const voucher = searchParams?.get("vc");

  return (
    <div className="popupBackground fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10">
      <div className={styles.deteleme}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-[40px] h-[40px] mb-[24px]"
        >
          <path
            id="Vector"
            d="M26.2929 8.22222C23.9135 4.47027 19.8616 2 15.2632 2C7.93812 2 2 8.26802 2 16C2 23.732 7.93812 30 15.2632 30C19.1913 30 22.7206 28.1974 25.1491 25.3333M21.1579 16.4444L23.8105 19.1111L30 12.8889M15.2632 9.77778V17.5556M15.2632 22.2222H15.2779"
            stroke={buttonColor || "#A2C4CD"}
            stroke-width="2.69"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <p
          className="text-regular-medium px-[20px] mb-[16px]"
          style={{ color: buttonColor }}
        >
          {voucher}
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px]">
          Here is your voucher code for participating. Please click 'Next' to
          continue.{" "}
        </p>
        <div className="seperator my-[20px]" />
        <div className="flex flex-col gap-[16px] w-[100%]">
          <button
            className={styles.Deeleeete}
            onClick={handleNext}
            style={{
              backgroundColor: buttonColor,
              color: "#000",
            }}
            disabled={loading}
          >
            <p className="text-regular-medium">
              {loading ? "Loading" : "Next"}
            </p>
          </button>
          <button onClick={() => setPopup(false)}>
            <p>Cancel</p>
          </button>
        </div>
      </div>
    </div>
  );
}

export default VoucherPaymentPopup;
